export class UnscheduledParcelShipmentsResposne {
  unscheduledShipmentsExist?: boolean;

  constructor(opts?: Partial<UnscheduledParcelShipmentsResposne>) {
    if (opts?.unscheduledShipmentsExist != null) {
      this.unscheduledShipmentsExist = opts.unscheduledShipmentsExist;
    }
  }
}
